export default {
      id: "id-tag-usage",
      viewBox: "-1 -1 24 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#id-tag",
      toString: function () {
        return this.url;
      }
    }